import {
    EXPORT_INVOICES,
    EXPORT_INVOICES_FAILURE,
    EXPORT_INVOICES_SUCCESS,
    EXPORT_INVOICES_LINES,
    EXPORT_INVOICES_LINES_FAILURE,
    EXPORT_INVOICES_LINES_SUCCESS,
} from 'store/actions/types';

export const exportInvoices = (payload) => {
    return {
        type: EXPORT_INVOICES,
        payload,
    };
};

export const exportInvoicesFailure = (error) => {
    return {
        type: EXPORT_INVOICES_FAILURE,
        error,
    };
};

export const exportInvoicesSuccess = () => {
    return {
        type: EXPORT_INVOICES_SUCCESS,
    };
};

export const exportInvoicesLines = (payload) => {
    return {
        type: EXPORT_INVOICES_LINES,
        payload,
    };
};

export const exportInvoicesLinesFailure = (error) => {
    return {
        type: EXPORT_INVOICES_LINES_FAILURE,
        error,
    };
};

export const exportInvoicesLinesSuccess = () => {
    return {
        type: EXPORT_INVOICES_LINES_SUCCESS,
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/invoices/exportInvoices.js